import { GlobalStyles } from '@mui/material';

/**
 * Optimización de Impresión para 3 Corazones.
 * Ajustado para que el PDF se vea igual que la web.
 */
export const handlePrint = () => {
  window.print();
};

export const printStyles = (
  <GlobalStyles
    styles={{
      '@media print': {
        '*': {
          WebkitPrintColorAdjust: 'exact !important',
          printColorAdjust: 'exact !important',
        },
        '.no-print': {
          display: 'none !important',
        },
        '@page': {
          size: 'A4 portrait',
          margin: '0',
        },
        'body': {
          backgroundColor: '#FFFAF9 !important', // Coincide con background.default de la web
          margin: '0 !important',
          padding: '0 !important',
        },
        '.catalog-template-root': {
          backgroundImage: 'radial-gradient(#FFB7C5 0.5px, transparent 0.5px) !important',
          backgroundSize: '20px 20px !important',
          backgroundColor: '#FFFAF9 !important',
        },
        '.print-only-cover': {
          display: 'flex !important',
          height: '297mm !important',
          width: '210mm !important',
          pageBreakAfter: 'always !important',
          breakAfter: 'page !important',
          margin: '0 !important',
          padding: '20mm !important',
          backgroundColor: '#FFF5F7 !important',
          backgroundImage: 'radial-gradient(circle at 50% 50%, #FFB7C5 0%, transparent 80%) !important',
        },
        '.MuiContainer-root': {
          maxWidth: 'none !important',
          width: '100% !important',
          padding: '10mm !important',
          margin: '0 !important',
          backgroundColor: 'transparent !important',
        },
        '.product-card-container': {
          backgroundColor: 'transparent !important',
          minHeight: '85mm !important', // Permite que crezca si es necesario
          display: 'flex !important',
          flexDirection: 'row !important',
          alignItems: 'center !important',
          justifyContent: 'space-between !important',
          marginBottom: '0 !important',
          padding: '10mm 5mm !important',
          pageBreakInside: 'avoid !important',
          borderBottom: 'none !important', // Eliminamos el dashed para que se vea como la web
          overflow: 'hidden !important',
          boxSizing: 'border-box !important',
        },
        '.footer-section': {
          pageBreakInside: 'avoid !important',
          marginTop: '10mm !important',
          padding: '10mm !important',
          border: '2px dashed #FFB7C5 !important',
          borderRadius: '16px !important',
          backgroundColor: '#FFFFFF !important',
          boxShadow: 'none !important',
        },
        // Forzamos el zigzag en impresión
        '.product-card-container:nth-of-type(even)': {
          flexDirection: 'row-reverse !important',
        },
        // Ajuste de la imagen en impresión
        '.product-card-container > div:nth-of-type(2)': {
          width: '75mm !important',
          height: '75mm !important',
          minWidth: '75mm !important',
          flexShrink: '0 !important',
          margin: '0 5mm !important',
        },
        // Ajuste del contenido de texto
        '.product-card-container > div:last-child': {
          flex: '1 !important',
          padding: '0 5mm !important',
        },
        '.product-card-container:nth-of-type(even) > div:last-child': {
          textAlign: 'right !important',
        },
        '.product-card-container:nth-of-type(odd) > div:last-child': {
          textAlign: 'left !important',
        },
        '.floating-element': {
          display: 'block !important',
          opacity: '0.4 !important',
        },
        'h1': {
          fontSize: '3.5rem !important',
          margin: '10mm 0 5mm 0 !important',
          textAlign: 'center !important',
        },
        'h2': {
          fontSize: '1.8rem !important',
          margin: '0 !important',
        },
        'h3': {
          fontSize: '2.2rem !important',
          margin: '0 0 5mm 0 !important',
        },
        'h4': {
          fontSize: '1.4rem !important',
          margin: '2mm 0 !important',
        },
        'h5': {
          fontSize: '1.2rem !important',
          marginBottom: '10mm !important',
          textAlign: 'center !important',
        },
        'h6': {
          fontSize: '1rem !important',
          margin: '0 0 5mm 0 !important',
        },
        '.MuiTypography-body1': {
          fontSize: '0.9rem !important',
          margin: '1mm 0 !important',
        },
        '.MuiTypography-body2': {
          fontSize: '0.75rem !important',
          lineHeight: '1.2 !important',
        },
        '.MuiTypography-overline': {
          fontSize: '0.65rem !important',
        }
      },
    }}
  />
);
